import { Component, ChangeDetectionStrategy } from '@angular/core';
import { EditorComponentBase, SlideToggleComponent } from 'ngx-lib';

@Component({
    selector: 'app-toggle-editor',
    templateUrl: './toggle-editor.component.html',
    styleUrls: ['./toggle-editor.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [SlideToggleComponent]
})
export class ToggleEditorComponent extends EditorComponentBase<boolean> {
    constructor() {
        super();
    }

    dataChanged(value: boolean): void {
        this.bindingProperty = value;
        this.valueChange.emit();
    }
}
